export const draggableBootstrapModal = (el: HTMLElement) => {
    // Prevent duplicate listener registration when `initializeModal()` is called multiple times.
    // (This happens frequently in React due to remounts/re-renders.)
    if ((el as any)?.dataset?.draggableBootstrapModalInitialized === 'true') {
        return;
    }
    (el as any).dataset.draggableBootstrapModalInitialized = 'true';

    // Body scroll state is owned centrally by `modal-scroll-state.util.ts`, reconciled from
    // live DOM state. It must NOT be toggled here: these listeners were registered per modal
    // element, so when modal #2 was opened over modal #1, modal #1's deferred
    // `hidden.bs.modal` removed the class while modal #2 was still shown — which is what made
    // the scrollbar disappear.

    let object = el.querySelector('.modal-dialog') as HTMLElement;
    let initX: number, initY: number, firstX: number, firstY: number;
    const modalHeader = el.querySelector('.modal-header') as HTMLElement;

    modalHeader.addEventListener('mousedown', startMove, false);
    modalHeader.addEventListener('touchstart', startMove, false);

    function startMove(e: MouseEvent | TouchEvent) {
        e.preventDefault();
        initX = object.offsetLeft;
        initY = object.offsetTop;

        if ('touches' in e) {
            firstX = e.touches[0].pageX;
            firstY = e.touches[0].pageY;
        } else {
            firstX = e.pageX;
            firstY = e.pageY;
        }

        window.addEventListener('mousemove', dragIt, false);
        window.addEventListener('touchmove', dragIt, false);

        // Mouse/touch can be released outside the header; listen on window so drag always stops.
        const stopMove = () => {
            window.removeEventListener('mousemove', dragIt, false);
            window.removeEventListener('touchmove', dragIt, false);
        };

        window.addEventListener('mouseup', stopMove, { once: true });
        window.addEventListener('touchend', stopMove, { once: true });
        window.addEventListener('touchcancel', stopMove, { once: true });
        window.addEventListener('blur', stopMove, { once: true });
    }

    function dragIt(e: MouseEvent | TouchEvent) {
        object.classList.add('has-been-dragged');
        //console.log('dragging')

        let currentX: number, currentY: number;
        if ('touches' in e) {
            currentX = e.touches[0].pageX;
            currentY = e.touches[0].pageY;
        } else {
            currentX = e.pageX;
            currentY = e.pageY;
        }

        object.style.left = `${initX + currentX - firstX}px`;
        object.style.top = `${initY + currentY - firstY}px`;

        const headerHeight = modalHeader.getBoundingClientRect().height || 0;

        // If dialog is larger than viewport, allow negative positions but keep at least the header reachable.
        const maxLeftRaw = window.innerWidth - object.clientWidth;
        const minLeft = Math.min(0, maxLeftRaw);
        const maxLeft = Math.max(0, maxLeftRaw);

        const maxTopRaw = window.innerHeight - object.clientHeight;
        const minTopRaw = Math.min(0, maxTopRaw);
        const minTop = Math.max(minTopRaw, -(object.clientHeight - headerHeight));
        const maxTop = Math.max(0, maxTopRaw);

        const clampedLeft = Math.min(maxLeft, Math.max(minLeft, object.offsetLeft));
        const clampedTop = Math.min(maxTop, Math.max(minTop, object.offsetTop));

        object.style.left = `${clampedLeft}px`;
        object.style.top = `${clampedTop}px`;
    }
}